export default "__VITE_ASSET__II9HUXoq__"